import { get } from 'pc-sales/utils/http';

export class DetailsApi {
    // 获取详情页模块交易账号列表
    mtAccounts = (data: {
        uuid: string;
        page: number;
        pagesize: number;
        is_group?: boolean;
    }) => get('/v2/client/details/mtAccounts', data);

}

export default new DetailsApi();
